module.exports = "/images/bus.jpg?6b6e915ba92b54f9598587bbfe71fec5";